module.exports = __webpack_public_path__ + "static/media/vfiLogo.61b0b64b.png";